let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g3gOG")).then(() => parcelRequire('6I16N'));